<div class="info" [@zoomIn]="true">
    <div class="container-fluid head">
        <div *ngIf="pdv?.image" class="row image" oncontextmenu="return false;" [ngClass]="{loading:!loadAvatar}">
            <img [alt]="pdv?.name" loading [src]="pdv.image|absolutePath:'img'" style="position: relative" width="100%"
                (load)="loadAvatar=true">
        </div>
    </div>
    <div class="container">
        <div class="row livraison">
            <div class="col-md-12" style="margin-bottom: 18px;">
                <h3 class="heading" *ngIf="pdv?.comment">Le Restaurant :</h3>
                <hr class="half_space" *ngIf="pdv?.comment">
                <div *ngIf="pdv?.comment" [innerHtml]="pdv?.comment" class="comment"></div>
            </div>
            <div class="col-md-6" *ngIf="authorizedCities?.length>0">
                <h3 class="heading">Zones de livraison:</h3>
                <hr class="half_space">
                <table class="table-striped" width="100%">
                    <thead>
                        <th>Zone</th>
                        <th style="text-align: center;">Min de commande</th>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let zone of authorizedCities; let i = index">
                            <tr [hidden]="i > 5 && !displayAll">
                                <td>
                                    <a href="/commander/livraison-{{pdv.speciality}}-{{ zone.name | lowercase }}-{{
                                  zone.postalCode
                                }}" title="livraison {{ zone.name }} {{ zone.postalCode }}">{{ zone.name }}
                                        {{ zone.postalCode }}</a>
                                </td>
                                <td class="text-center">{{ zone.amountMiniDelivery }}€</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <button class="btn more" *ngIf="authorizedCities.length > 6" (click)="displayAll = !displayAll">
                    Voir
                    <ng-container *ngIf="!displayAll">
                        plus ...
                    </ng-container>
                    <ng-container *ngIf="displayAll">
                        moins ...
                    </ng-container>
                </button>
            </div>
            <div class="col-md-6">
                <h3 class="heading">Contact</h3>
                <hr class="half_space">
                <p>
                    <img src="assets/images/restaurant.svg" style="margin-right: 6px;" width="32px" [alt]="pdv?.name">
                    {{pdv?.name}}
                </p>
                <p class="address">
                    <i class="flaticon-pin"></i>
                    <a href="#" #maplink target="_blank"> {{pdv?.address}}</a>
                </p>
                <p class="phone">
                    <i class="flaticon-phone-on-circle"></i>
                    <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
                </p>
                <p class="email" *ngIf="pdv?.emailContact">
                    <i class="flaticon-arroba"></i>
                    <a href="mailto:{{pdv?.emailContact}}">
                        {{pdv?.emailContact}}
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- <ngui-map zoom="16" [center]="pdv?.address" class="map">
    <marker [position]="pdv?.address" [icon]="{url: 'assets/images/icon2.png'}" (click)="onpenMarker($event)"
        (initialized$)="onMarkerInit($event)"></marker>
    <info-window id="iw">
        <span>{{pdv.address}}</span>
    </info-window>
</ngui-map> -->
<!-- <agm-map [latitude]="lat" [longitude]="lng">
    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
</agm-map> -->
<div id="map"></div>